// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__owhrl","subheader":"ReorderModal_subheader__2LFDR","listWrap":"ReorderModal_listWrap__1minf"};